import AiAgentModel from '../../../../components/units/Management/AiAgent/Model/List';

export default function AiAgentModelPage() {
  return <AiAgentModel />;
}
